/**
 * TraditionsTabs — slim segmented control at the top of the Lexicon.
 * Lets the seeker pivot between the Traditions index (roots) and the
 * Concepts archive (terms shared across them).
 *
 * Sits on top of both /traditions and /archive so either page feels
 * like a face of the same lexicon.
 */
import React from "react";
import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/traditions", label: "Traditions", testid: "lexicon-tab-traditions" },
  { to: "/archive", label: "Concepts", testid: "lexicon-tab-concepts" },
];

export default function TraditionsTabs() {
  return (
    <div
      data-testid="lexicon-tabs"
      className="flex items-center gap-1 mb-10 border border-border rounded-full p-1 w-fit bg-secondary/40"
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end
          data-testid={t.testid}
          className={({ isActive }) =>
            `mono text-[10px] sm:text-[11px] uppercase tracking-[0.22em] px-4 sm:px-5 py-2 rounded-full transition-colors ${
              isActive
                ? "bg-background text-[hsl(var(--primary))] shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
